import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="CTO Service">
                <h1>CTO As A Service</h1>
              </div>
              <p className="main_para">
                Augment your team and scale your resources by hiring experienced
                tech leadership for the enterprise level to provide guidance and
                strategic direction for their technology initiatives.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Work with C-level tech executives and seasoned technology
                leaders to experience fundamental digital transformation,
                business agility, and growth.
              </p>
              <ul>
                <li>Strategic Technology Advisory</li>
                <li>Expert-Led Tech Automation</li>
                <li>Effective Development Management</li>
                <li>Change Planning, Execution & Control</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
